import styled from "styled-components";
import { StyledEditableInput } from "../../../../components/inline-edit/styled";

const options = {
  opacity: {
    [true]: 1,
    [false]: 0.25,
  },
};

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 10px;
`;

export const TabContainer = styled.div`
  background-color: ${({ theme, isSelected = false }) =>
    isSelected ? `${theme.text.brand}26` : "transparent"};
  border: 1px solid ${({ theme }) => theme.border.black50};
  padding: 6px 12px;
  color: ${({ theme }) => theme.border.black50};
  transition: background-color ease 0.1s, color ease 0.1s;
  font-size: 12px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;

  &:last-child {
    z-index: 10;
  }

  &:hover {
    background-color: ${({ theme }) => theme.text.brand}33;
  }
`;

export const TabButton = styled.div`
  background-color: transparent;
  cursor: pointer;
  display: grid;
  place-content: center;
  opacity: ${({ hasOpacity = true }) => options.opacity[hasOpacity]};

  ${({ hasRotation = false }) =>
    hasRotation &&
    `
      transform: rotate(180deg)
    `};
`;

export const TabButtonsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const NewTabButton = styled(TabButton)`
  height: 32px;
  box-sizing: border-box;
  border: 0.5px dashed ${({ theme }) => theme.text.text};
  border-radius: 9999px;
  padding-inline: 12px;
  transition: background-color ease 0.1s;
  z-index: 10;

  &:hover {
    background-color: rgba(0, 175, 255, 0.15);
  }
`;

export const TabsGroupContainer = styled.div`
  max-width: 100%;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 50px;
    background: linear-gradient(
      90deg,
      ${({ theme }) => theme.bg.general}00 0%,
      ${({ theme }) => theme.bg.general}40 25%,
      ${({ theme }) => theme.bg.general}80 50%,
      ${({ theme }) => theme.bg.general}ff 75%,
      ${({ theme }) => theme.bg.general}ff 100%
    );
  }
`;

export const EditableInput = styled(StyledEditableInput)`
  cursor: pointer;

  &:focus {
    cursor: text;
  }
`;
